import { useTheme } from '../../ThemeProvider/ThemeProvider';
import { THEMES } from '../../themes/themes';
import { cn } from '../../lib/cn';

export interface ThemePickerProps {
  value?: string;
  onChange?: (themeId: string) => void;
  variant?: 'overlay' | 'surface';
}

export function ThemePicker({ value, onChange, variant = 'overlay' }: ThemePickerProps) {
  const context = useTheme();
  const themeId = value ?? context.themeId;
  const setThemeId = onChange ?? context.setThemeId;
  const surface = variant === 'surface';

  return (
    <div
      className="grid grid-cols-2 gap-2 px-3.5 pb-2 pt-1"
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
    >
      {THEMES.map((theme) => {
        const active = themeId === theme.id;
        return (
          <button
            key={theme.id}
            type="button"
            onMouseDown={(e) => {
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.stopPropagation();
              setThemeId(theme.id);
            }}
            className={cn(
              'flex min-w-0 cursor-pointer items-center gap-2 overflow-hidden rounded-[10px] border px-2 py-1.5 text-left font-[inherit]',
              surface
                ? active
                  ? 'border-[var(--ai-3)] bg-[var(--ai-tint)]'
                  : 'border-[var(--cream-2)] bg-[var(--cream-1)] hover:bg-[var(--cream-0)]'
                : active
                  ? 'border-white/50 bg-white/15'
                  : 'border-white/10 bg-white/5',
            )}
          >
            <span
              className="relative h-[26px] w-[26px] shrink-0 overflow-hidden rounded-md border border-black/20"
              style={{ background: theme.page }}
            >
              <span
                className="absolute left-[3px] top-[3px] h-3 w-3 rounded border border-black/10"
                style={{ background: theme.surface }}
              />
              <span
                className="absolute bottom-[3px] right-[3px] h-2 w-2 rounded-full"
                style={{ background: `linear-gradient(135deg, ${theme.accent[0]}, ${theme.accent[2]})` }}
              />
            </span>
            <span className="min-w-0 flex-1 overflow-hidden">
              <span
                className={cn(
                  'block truncate text-[10.5px] font-semibold leading-tight',
                  surface ? 'text-[var(--ink-0)]' : 'text-white',
                )}
                title={theme.name}
              >
                {theme.name}
              </span>
              <span
                className={cn(
                  'mt-px block truncate text-[9px] leading-tight',
                  surface ? 'text-[var(--ink-3)]' : 'text-white/50',
                )}
              >
                {theme.dark ? 'Dark' : 'Light'}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
